module.exports = __webpack_public_path__ + "amazon-prime.2821774c351a0e9079f230ad4b312a71.svg";